import styled from 'styled-components';

import { ExclamationCircleIcon } from '@interstate/components/Icons';
import { Box } from '@interstate/components/Box';

export const SearchBarErrorContainer = styled.div`
    margin-top: ${({ theme }) => theme.tokens.BaseSpace50};
`;

export const SearchBarErrorLabel = styled.h3`
    margin-bottom: 0;
`;

export const SearchBarErrorDescription = styled.p`
    margin-bottom: 0;
`;

export const SearchSpinnerContainer = styled.div`
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;

    .ai-search-status-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
    }

    #ai-search-status {
        font-size: 25px;
    }

    #ai-search-similarity-status {
        font-size: 20px;
    }
`;

export const StyledSearchBarContainer = styled(Box)<{ hasError?: boolean }>`
    margin-top: 16px;
    > div:first-of-type {
        border-color: ${({ theme, hasError }) => (hasError ? theme.tokens.BaseColorRed600 : theme.tokens.BaseColorGray400)};
    }
`;

export const ErrorMessageContainer = styled(Box)`
    display: flex;
    align-items: flex-start;
    gap: 4px;
    padding: 8px 0;
`;

export const ErrorTextContainer = styled(Box)`
    color: ${({ theme }) => theme.tokens.BaseColorRed600};
    line-height: ${({ theme }) => theme.tokens.ComponentAlertFontLineHeight};
    font-size: ${({ theme }) => theme.tokens.ComponentAlertFontSize};
    font-weight: ${({ theme }) => theme.tokens.ComponentAlertFontWeight};
`;

export const ErrorMessageIcon = styled(ExclamationCircleIcon)`
    fill: ${({ theme }) => theme.tokens.BaseColorRed600};
    width: 1em;
    height: 1em;
    font-size: ${({ theme }) => theme.tokens.ComponentAlertFontSize};
`;

// Bottom spacing for a results-area block (search results and the AVO section). Shared here so the AVO
// section doesn't reach into AiAssistedSearch's own style module.
export const SearchResultsContainer = styled.div`
    margin-bottom: ${({ theme }) => theme.tokens.BaseSpace50};
`;
